<template>
    <div :class="clContainer()">
        <span v-if="label && (!hideLabelState || state != hideLabelState)" :class="clSub('label', 'label')">{{label}}</span>
        <p :class="clSub('value', textClass)">
            <slot v-if="!allSelected || !allSelectedText" name="text" :options="options" :selected="selected">
                {{text}}
            </slot>
            <span v-else>{{allSelectedText}}</span>
        </p>

        <div :class="clSub('input', `form__input ${inputClass}`)" @click="($event) => { if(opened) $event.stopPropagation() }">
            <div :class="{ [ baseClass + '__select' ]: true, opened: opened }">
                <button type="button" @click="opened = !opened">
                    <slot v-if="!allSelected || !allSelectedText" name="text" :options="options" :selected="selected">
                        {{text}}
                    </slot>
                    <span v-else>{{allSelectedText}}</span>
                </button>

                <ul :class="clSub('select__options', 'list-reset')">
                    <slot />
                    <slot name="option" v-for="option in options" :option="option">
                        <editable-multi-select-option :data="option" :text="option[textKey] || undefined"></editable-multi-select-option>
                    </slot>
                </ul>
            </div>
        </div>

        <div :class="clSub('errors')">
            <div v-for="(error, index) in errors" :class="clSub('error')" :key="index">
                {{ error }}
            </div>
        </div>
    </div>
</template>

<script>
import Base from "./Base";

export default {
    extends: Base,
    props: {
        typeClass: {
            type: String,
            default: 'multi-select'
        },
        value: {
            type: Array,
            default() {
                return [];
            }
        },
        valueKey: {
            type: String,
            default: 'value'
        },
        textKey: {
            type: String,
            default: 'text'
        },
        allSelectedText: {
            type: String
        }
    },
    data() {
        return {
            options: [],
            selected: [],
            opened: false,
            optionChildren: []
        }
    },
    computed: {
        text() {
            if(this.selected.length == 0) {
                return this.noValText;
            }

            return this.allSelectedText && this.allSelected
                ? this.allSelectedText 
                : this.selected.map(o => o[this.textKey]).join(', ');
        },
        allSelected() {
            return this.selected.length == this.optionChildren.length;
        },
        allOptions() {
            return this.optionChildren.map(child => child.option ? { 
                child: child,
                data: child.option
            } : { 
                child: child,
                data: {
                    [ this.valueKey ]: child.value, 
                    [ this.textKey ]: child.text 
                }
            });
        },
        hasValue() {
            return this.data.length > 0;
        },
        formData() {
            return this.hasValue ? this.data : undefined;
        }
    },
    created() {
        document.addEventListener('click', () => { this.opened = false; })

        this.$on('selected', this.select);
        this.$on('deselected', this.deselect);

        this.$on('option-created', child => {
            this.optionChildren.push(child);
        });

        this.$on('option-destroyed', child => {
            let childIndex = this.optionChildren.indexOf(child);

            if(childIndex != -1) {
                this.optionChildren.splice(childIndex, 1);
            }
        });
    },
    methods: {
        setData(newData) {
            newData = this._setData(newData);

            if(Array.isArray(newData)) {
                let selected = [];

                this.allOptions.forEach(option => {
                    child.isSelected = newData.indexOf(option.data[this.valueKey]) != -1;

                    if(child.isSelected) {
                        selected.push(child.optionData);
                    }
                });

                this.selected = selected;
            } else {
                this.selected = newData;
            }
        },
        select(option) {
            this.selected.push(option);

            this.data.push(this.valueKey in option ? option[this.valueKey] : option);

            this.dataChanged();
        },
        deselect(option) {
            let optionIndex = this.selected.findIndex(o => o[this.valueKey] == option[this.valueKey]);
            let dataIndex = this.data.indexOf(this.valueKey in option ? option[this.valueKey] : option);

            if(dataIndex != -1) {
                this.data.splice(dataIndex, 1);
            }

            if(optionIndex != -1) {
                this.selected.splice(optionIndex, 1);
                this.dataChanged();
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .editable__element {
        &__input {
            position: relative;
        }

        &__select {
            &__options {
                position: absolute;
                left: 0;
                top: 100%;
            }

            &:not(.opened) &__options {
                display: none;
            }
        }
    }
</style>